import { css } from 'linaria';
import { TooltipPropsBase, Variables } from '../index';

export const tooltip = css`
    border-radius: 4px;
    pointer-events: none;
    padding: 3px 8px;
    max-width: 420px;
`;

export const content = css`
    transform-origin: var(--radix-tooltip-content-transform-origin);
    animation: anim 250ms cubic-bezier(0.22, 0.61, 0.36, 1) forwards;

    @keyframes anim {
        0% {
            opacity: 0;
            transform: scale(0.7);
        }

        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
`;

export const arrowColor: Record<TooltipPropsBase['variant'], string> = {
    alert: css`
        fill: ${Variables.css.alert};
    `,
    default: css`
        fill: ${Variables.css.grey2};
    `,
};

export const backgroundColors: Record<TooltipPropsBase['variant'], string> = {
    alert: css`
        background-color: ${Variables.css.alertBg};
        border: solid;
        border-width: 2px;
        border-color: ${Variables.css.alert};
    `,
    default: css`
        background-color: ${Variables.css.grey2};
    `,
};
